/**
 * @file    BankOperationTabs.css
 *
 *          Styles the bank operations tabs component.
 *
 * @author  Daniel Akbarzadeh <danny@kingsds.network>
 * @author  Kevin Yu <kevin@distributive.network>
 * @date    June 2022
 */

.buy button {
  margin-top: 15px;
}

#bank-operations-tab {
  /* React Tabs Overwrite */
  white-space: nowrap;
  height: max-content;
  width: 100%;
  max-width: 350px;
  min-height: 237px;
  display: flex;
  flex-direction: column;
  padding-bottom: 1rem;

  input[type="number"] {
    -moz-appearance: textfield;
  }

  @media only screen and (max-width: 640px) {
    width: 100%;
    max-width: none;

    .split {
      display: block;
    }
  }

  .inlineinput select,
  .inlineinput input {
    font-size: 0.9rem;
  }

  > div {
    flex-grow: 1;
    height: 100%;
  }

  form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    flex-grow: 1;
  }

  form button {
    align-self: flex-end;
    margin-top: 16px;
  }

  .react-tabs__tab {
    bottom: -1.4px;
  }

  .react-tabs__tab:focus::after {
    left: 0; /* Removes the white space on the far left tab when focused*/
    right: 0; /* Removes the white space on the far right tab when focused*/
  }

  .react-tabs__tab-list {
    margin-bottom: 0;
  }

  .react-tabs__tab-panel {
    border: solid 1px var(--content-hue-light);
    border-top: 0 transparent none;
    padding: 15px;
  }

  .react-tabs__tab-panel--selected {
    display: flex;
    flex-direction: column;
  }

  button {
    margin-left: auto;
  }

  /* TODO: Remove this when DCP-CLIENT STYLES are formalized */
  /* Appearance for button pre-activation */
  form {
    INPUT[type="submit"]:focus-visible,
    INPUT[type="reset"]:focus-visible,
    INPUT[type="button"]:focus-visible,
    BUTTON[type="button"]:focus-visible,
    BUTTON[primary]:focus-visible,
    BUTTON:focus-visible {
      outline: 2px solid var(--primary-hue-lighter);
      outline-offset: 2px;
      border-radius: 0.5px;

      z-index: 1;
    }
  }
}
